import React from 'react';

class NotFound extends React.Component {
    render() {
      return (
        <div>
          <div className="hdr error">
            <div className="gry"></div>
            <div className="icon icon-error"></div>
            <h2>صفحه موردنظر وجود ندارد - ۴۰۴</h2>
          </div>
          <div className="item">
            <p>کاربر عزیز<br /></p>
            <p>صفحه مورد نظر يافت نشد. ممکن است آدرس صفحه را اشتباه درج نموده باشيد و يا اينکه لينک مورد نظر غير فعال شده باشد.</p>
            <br /><br />
            <p>با تشکر<br /></p>
            <div className="clr"></div>
          </div>
        </div>
      );
    }
  }
  export default NotFound;